import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { Observable, Subscription, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators'; // Import operators
import { ActivatedRoute } from '@angular/router';
import { BriefSectionComponent } from "../../brief-section/brief-section.component";

@Component({
  selector: 'app-applicant-eoi-view',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, BriefSectionComponent],
  templateUrl: './applicant-eoi-view.component.html',
  styleUrl: './applicant-eoi-view.component.css'
})
export class ApplicantEoiViewComponent implements OnInit {
  projectIdNew: string;
  submittedInitiation: any;
  constructor(
    private projectsService: ProjectsService,
    public dialog: MatDialog,
    private GetProjectIdService : GetProjectIdService,
    private activeRoute : ActivatedRoute
  ) {}

  isDialogOpen = false;
  applicantViewData: any;
  eoi_id : number;
  private subscription: Subscription = new Subscription();

  ngOnInit(): void {

    this.eoi_id = Number(this.activeRoute.snapshot.paramMap.get('id'));

    this.getApplicantEoiView();
    this.submittedInitiationData();
    this.subscription = this.GetProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if(!this.projectIdNew){
        this.projectIdNew = this.GetProjectIdService.getProjectId();
      }
      this.getApplicantEoiView();
      this.submittedInitiationData();
    });

    // this.getExpressionOfInterest();
  }


  submittedInitiationData(): any {
    console.log("errtyr");
    
    return this.projectsService.getSubmittedInitiationData().subscribe({
      next: (data: any) => {
        this.submittedInitiation = data.data;
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }


  getApplicantEoiView() {
    this.projectsService.getApplicantEoiView(this.projectIdNew, this.eoi_id).subscribe({
      next: (data) => {
        this.applicantViewData = data?.data;
  
        if (data?.data?.country_id) {
          this.getCountryData(this.applicantViewData.country_id).subscribe((countryName) => {
            if (countryName) {
              data.data.country_id = countryName;
              this.applicantViewData = data?.data;
              console.log('Applicant View data fetched successfully:', this.applicantViewData);
            } else {
              console.log('No country data available for the given ID.');
            }
          });
        }
  
        // console.log('Applicant View data fetched successfully:', this.applicantViewData);
      },
      error: (error) => {
        console.error('Error fetching Applicant View data:', error);
      },
    });
  }
  

  getCountryData(country_id: any): Observable<any> {
    return this.projectsService.getCountry(country_id).pipe(
      map((data: any) => data?.data?.name), // Extract the country name
      catchError((error) => {
        console.error('Error fetching country data:', error);
        return of(null); // Return a default value or `null` on error
      })
    );
  }
  
  closeDialog(): void {
    this.dialog.closeAll();
  }

  print() {

    this.closeDialog();
  }
}
